import React from 'react';
import Anime from 'react-anime';
import { isMobile } from 'react-device-detect';
import './VerticalDrop.scss';
import pipeImg from '../assets/elements/pipe/Middle.png';
import pipeCapImg from '../assets/elements/pipe/Opening-top.png';
export default ( { isActive }) => {
  const ball1 = {
    top: [
      { value: '-25vh', duration: 0, easing: 'linear'},
      { value: () => {
        return isMobile ? '55vh' : '65vh';
      }, duration: 1500, easing: 'easeOutSine'},
      { value: '200vh', duration: 1500, easing: 'easeInSine', delay: 3000}
    ],
    left: [
      { value: '33%', duration: 0, delay: 2000},
      { value: 0, duration: 1000, easing: 'linear'}
    ]
  }
  const ball2 = {
    top: [
      { value: '-25vh', duration: 0, easing: 'linear'},
      { value: () => {
        return isMobile ? '55vh' : '65vh';
      }, duration: 1500, easing: 'easeOutSine'},
      { value: '200vh', duration: 1500, easing: 'easeInSine', delay: 3750}
    ],
    left: [
      { value: '33%', duration: 0, delay: 2000},
      { value: '33%', duration: 1000, easing: 'linear'}
    ]
  }
  const ball3 = {
    top: [
      { value: '-25vh', duration: 0, easing: 'linear'},
      { value: () => {
        return isMobile ? '55vh' : '65vh';
      }, duration: 1500, easing: 'easeOutSine'},
      { value: '200vh', duration: 1500, easing: 'easeInSine', delay: 3250}
    ],
    left: [
      { value: '33%', duration: 0, delay: 2000},
      { value: '66%', duration: 1000, easing: 'linear'}
    ]
  }
  return (
    <div className="pipe-vertical-drop">
      <div className="pipe pipe--1">
        <img src={pipeImg}  />
      </div>
      <div className="pipe-cap pipe-cap--1">
        <img src={pipeCapImg}  />
      </div>
      <div className="pipe-cap pipe-cap--1 pipe-cap--bottom">
        <img src={pipeCapImg}  />
      </div>
      {isActive && (
        <Anime {...ball1} className="ball ball--1"><div></div></Anime>
      )}
      <div className="pipe pipe--2">
        <img src={pipeImg}  />
      </div>
      <div className="pipe-cap pipe-cap--2">
        <img src={pipeCapImg}  />
      </div>
      <div className="pipe-cap pipe-cap--2 pipe-cap--bottom">
        <img src={pipeCapImg}  />
      </div>
      {isActive && (
        <Anime {...ball2} className="ball ball--2"><div></div></Anime>
      )}

      <div className="pipe pipe--3">
        <img src={pipeImg}  />
      </div>
      <div className="pipe-cap pipe-cap--3">
        <img src={pipeCapImg}  />
      </div>
      <div className="pipe-cap pipe-cap--3 pipe-cap--bottom">
        <img src={pipeCapImg}  />
      </div>
      {isActive && (
        <Anime {...ball3} className="ball ball--3"><div></div></Anime>
      )}

    </div>
  );
};